import { useEffect } from "react";
import i18n from "../../../constants/i18n";
import getCoreHistoryStore from "../../../stores/core/core-history-store";
import { withLiteObserverAndTheme } from "../../../core/et3-enhanced-render";
import ET3PageDiv from "../../../core/et3-page-div";
import Et3PageTitle from "../../../core/et3-page-title";
import Et3Margin from "../../../core/et3-ui/ET3Margin";
import StatsDashboardForm from "./stats-dashboard-form";
import StatsDashboardData from "./stats-dashboard-data";

const StatsDashboard = withLiteObserverAndTheme(() => {
  useEffect(() => {
    getCoreHistoryStore().setPageName("DEVELOPER_STATS", "DEVELOPER_STATS");
  }, []);

  return (
    <ET3PageDiv
      fDirection="column"
      alignItems="flex-start"
      justifyContent="flex-start"
      style={{}}
    >
      <Et3PageTitle
        title={i18n.get("STATS")}
        subTitle={i18n.get("STATS_DASHBOARD")}
        withRefresh={false}
        withHelper={false}
        onPress={() => {}}
      />
      <StatsDashboardForm />
      <Et3Margin top={30} bottom={0} left={0} right={0} />
      <StatsDashboardData />
    </ET3PageDiv>
  );
});

export default StatsDashboard;
